<template>
  <kst-print-table view-mode :data="summaryData.TransactionList">
    <b-table-column
      v-slot="{ row }"
      field="Label"
      :label="PlosSummaryCatalog.ModuleName.Label"
    >
    {{ row.Label }}
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-hpptotal"
      field="AddTotal"
      :label="PlosSummaryCatalog.AddTotal.Label"
    >
      <template v-if="row.AddTotal !== null">
        <kst-value :field="column.field" :data="row" :catalog="PlosSummaryCatalog"/>
      </template>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-hpptotal"
      field="SubTotal"
      :label="PlosSummaryCatalog.SubTotal.Label"
    >
      <template v-if="row.SubTotal !== null">
        <kst-value :field="column.field" :data="row" :catalog="PlosSummaryCatalog"/>
      </template>
    </b-table-column>
  </kst-print-table>
</template>

<script>
import PlosSummaryCatalog from "../PlosSummaryCatalog.js";

export default {
  props: {
    summaryData: Object
  },
  data: () => ({
    PlosSummaryCatalog: PlosSummaryCatalog
  })
}
</script>